'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageText = exports.FLOATING_IMAGE = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShopifySection2 = require('./../ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-image-text]'; /*
                                                                            *  Image Text
                                                                            *    Scripts to create a paralax effect for the image text section.
                                                                            *
                                                                            *  Version:
                                                                            *    1.0.0 - 2020/05/19
                                                                            */

var FLOATING_IMAGE = exports.FLOATING_IMAGE = '[data-image-text-image]';

var ImageText = exports.ImageText = function (_ShopifySection) {
  (0, _inherits3.default)(ImageText, _ShopifySection);

  function ImageText(container) {
    (0, _classCallCheck3.default)(this, ImageText);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageText.__proto__ || Object.getPrototypeOf(ImageText)).call(this, container));

    _this.image = container.find(FLOATING_IMAGE);
    _this.factor = -0.2; // How much you want to move based on percent

    _this.updateParallax();
    return _this;
  }

  (0, _createClass3.default)(ImageText, [{
    key: 'updateParallax',
    value: function updateParallax() {
      var _this2 = this;

      var rect = this.container[0].getBoundingClientRect();
      var top = rect.top;

      if (top != this.top) {
        var sTop = $(window).scrollTop();
        var eBottom = rect.bottom;
        var containerTop = this.container.offset().top;

        //Is this section in view?
        var visible = top < window.innerHeight && eBottom >= 0;

        if (visible) {
          var percent = (sTop + rect.height - containerTop) / rect.height * 100;

          this.image.css({
            "transform": 'translateY(' + (percent * this.factor).toFixed(1) + '%)',
            "-webkit-transform": 'translateY(' + (percent * this.factor).toFixed(1) + '%)'
          });
        }
      }

      this.top = top;
      requestAnimationFrame(function () {
        return _this2.updateParallax();
      });
    }
  }]);
  return ImageText;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, ImageText);